/* eslint-disable import/no-unresolved */

import {
  TENANT_AT,
  TENANT_COM,
  TENANT_IT,
  TENANT_FR,
  TENANT_TEST
} from 'shared/consts/tenants'

import logoComDesktop from 'views/assets/images/logos/logo-COM-desktop.svg'
import logoComMobile from 'views/assets/images/logos/logo-COM-mobile.svg'
import logoAtDesktop from 'views/assets/images/logos/logo-AT-desktop.svg'
import logoAtMobile from 'views/assets/images/logos/logo-AT-mobile.svg'
import logoItDesktop from 'views/assets/images/logos/logo-IT-desktop.svg'
import logoItMobile from 'views/assets/images/logos/logo-IT-mobile.svg'
import logoFrDesktop from 'views/assets/images/logos/logo-FR-desktop.svg'
import logoFrMobile from 'views/assets/images/logos/logo-FR-mobile.svg'
import logoTestMobile from 'views/assets/images/logos/logo-TEST-mobile.svg'
import logoTestDesktop from 'views/assets/images/logos/logo-TEST-desktop.svg'
import logoTestMobileCheckout from 'views/assets/images/logos/logo-TEST-mobile-checkout.svg'
import logoBaseMobileCheckout from 'views/assets/images/logos/logo-BASE-mobile-checkout.svg'

export const MOBILE = 'mobile'
export const DESKTOP = 'desktop'
export const MOBILE_CHECKOUT = 'mobileCheckout'
export const DESKTOP_CHECKOUT = 'desktopCheckout'

export const SHOP_LOGOS = {
  [TENANT_COM]: {
    [MOBILE]: logoComMobile,
    [DESKTOP]: logoComDesktop,
    [MOBILE_CHECKOUT]: logoBaseMobileCheckout,
    // FIXME when desktop checkout is available (all tenants)
    [DESKTOP_CHECKOUT]: logoBaseMobileCheckout
  },
  [TENANT_AT]: {
    [MOBILE]: logoAtMobile,
    [DESKTOP]: logoAtDesktop,
    [MOBILE_CHECKOUT]: logoBaseMobileCheckout,
    [DESKTOP_CHECKOUT]: logoBaseMobileCheckout
  },
  [TENANT_IT]: {
    [MOBILE]: logoItMobile,
    [DESKTOP]: logoItDesktop,
    [MOBILE_CHECKOUT]: logoTestMobileCheckout,
    [DESKTOP_CHECKOUT]: logoBaseMobileCheckout
  },
  [TENANT_FR]: {
    [MOBILE]: logoFrMobile,
    [DESKTOP]: logoFrDesktop,
    [MOBILE_CHECKOUT]: logoTestMobileCheckout,
    [DESKTOP_CHECKOUT]: logoBaseMobileCheckout
  },
  [TENANT_TEST]: {
    [MOBILE]: logoTestMobile,
    [DESKTOP]: logoTestDesktop,
    [MOBILE_CHECKOUT]: logoTestMobileCheckout,
    [DESKTOP_CHECKOUT]: logoBaseMobileCheckout
  }
}
SHOP_LOGOS.default = SHOP_LOGOS[TENANT_COM]
